/**
 * List-item marker patterns — single source of truth for detection + rendering.
 * Two forms intentionally differ:
 *   *_ITEM — matches an already-trimmed line (used while rendering).
 *   *_LINE — indentation-tolerant + multiline (used for content detection so
 *            indented/streamed lists still route to the renderer instead of the
 *            plain-text fallback that showed literal "1. 1. 1." — issue #781).
 */
export const UNORDERED_ITEM = /^[-*]\s+/;
export const ORDERED_ITEM = /^\d+\.\s+/;
export const UNORDERED_LINE = /^[ \t]*[-*]\s+/m;
export const ORDERED_LINE = /^[ \t]*\d+\.\s+/m;

/** Hoisted so the array and its regex literals are allocated once, not per call. */
export const MARKDOWN_PATTERNS: RegExp[] = [
  /^#{1,6}\s+/m,
  UNORDERED_LINE,
  ORDERED_LINE,
  /\*\*.*\*\*/,
  /\*.*\*/,
  /`.*`/,
  /```[\s\S]*```/,
  /^>\s+/m,
  /\[.*\]\(.*\)/,
  /\n---+\n/,
];

/**
 * Size per heading level. Every level renders as an <h6> — MUI mapped both the
 * h6 and subtitle1 variants onto that element, so the hierarchy has always been
 * carried by size alone, never by the heading level.
 */
export const MARKDOWN_HEADING_SIZE: Record<number, string> = {
  1: 'text-[1.25rem]',
  2: 'text-[1.1rem]',
  3: 'text-base',
};

export const MARKDOWN_HEADING_SIZE_FALLBACK = 'text-[0.9rem]';
